import "./OrganizationTree.css";
import OrganizationTreeItem from "./OrganizationTreeItem";
import { jsx as _jsx } from "react/jsx-runtime";
export default function OrganizationTree({
  onChange,
  treeBranch,
  treeCommand
}) {
  return /*#__PURE__*/_jsx("ol", {
    className: "OrganizationTree",
    "data-sentry-component": "OrganizationTree",
    "data-sentry-source-file": "OrganizationTree.tsx",
    children: treeBranch.map(org => /*#__PURE__*/_jsx(OrganizationTreeItem, {
      initalExpanded: treeBranch.length === 1,
      onChange: onChange,
      org: org,
      treeCommand: treeCommand
    }, org.name))
  });
}